import { useCallback, useState } from "react";

export function useStoredWidth(key, def, min, max) {
  const [w, setW] = useState(() => {
    const v = parseInt(localStorage.getItem(key), 10);
    return v >= min && v <= max ? v : def;
  });
  const save = useCallback((v) => {
    const c = Math.min(max, Math.max(min, Math.round(v)));
    setW(c);
    localStorage.setItem(key, String(c));
  }, [key, min, max]);
  return [w, save];
}

export function ResizeHandle({ width, onChange, testId, className = "" }) {
  const start = (e) => {
    e.preventDefault();
    const x0 = e.clientX;
    const w0 = width;
    const move = (ev) => onChange(w0 + ev.clientX - x0);
    const up = () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
      document.body.classList.remove("pgp-resizing");
    };
    document.body.classList.add("pgp-resizing");
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
  };
  return (
    <div role="separator" aria-orientation="vertical" title="Trascina per ridimensionare" onMouseDown={start} data-testid={testId}
      className={`group absolute top-0 -right-2 z-20 h-full w-4 cursor-col-resize ${className}`}>
      <div className="mx-auto h-full w-0.5 rounded bg-transparent group-hover:bg-amber-500/70 transition-colors" />
    </div>
  );
}
